// extracted by mini-css-extract-plugin
export default {"button":"H31Uu","hiddenLabel":"th4QX"};